import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';
import Flip from 'react-reveal/Flip';

import Resume from "../../files/resume.pdf";
import "./About.scss";

class About extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: props.data
        };
    }

    render() {

        let bio = this.state.data.bio;

        return (
            <section id="about">
                <Fade top delay={100} duration={800} distance="100%" fraction={0.01}>
                    <div className="section-background"></div>
                </Fade>
                <Container fluid>
                    <Row>
                        <Fade left delay={200} duration={800} distance="20%" fraction={1}>
                            <h2 className="section-title">About Me</h2>
                        </Fade>
                        <Fade right delay={400} duration={800} distance="500px" fraction={1}>
                            <div className="section-title-underline"></div>
                        </Fade>
                    </Row>
                    <Row>
                        <Zoom delay={500} duration={800} fraction={1}>
                            <p className="description">{bio}</p>
                        </Zoom>
                    </Row>
                    <Row className="justify-content-center">
                        <Flip left delay={600} duration={1000} fraction={1}>
                            <Link className="download-resume" to={Resume} target="_blank" download>
                                <FontAwesomeIcon icon={faDownload} />
                                <span>Download Resume</span>
                            </Link>
                        </Flip>
                    </Row>
                </Container>
            </section>
        );
    }
};

export default About;
